import React from 'react';
import classnames from 'classnames';
import { svgProps } from './svg-properties';
import { useId } from "react-id-generator";
import { useTranslation } from 'react-i18next';

interface MetsIconPropTypes {
    /** Additional classNames that can be supplied to the SVG element. */
    className?: string,
    /** The prefix used to generated an ID for different elements. If this is null, a default will be generated. */
    idPrefix?: string,
    /** The name of the METS icon to be used. This is required and must map one of the predefined icon types. */
    name: string,
    /** Function that is executed when the user clicks the icon. */
    onClick?: (e: React.MouseEvent<SVGElement>) => void
}

/**
 * Generic Icon component that renders an svg icon from a sprite served by the METS application server.
 * 
 * @param {object} props 
 */
function MetsIcon(props: MetsIconPropTypes) {

    const { t } = useTranslation();
    const [htmlId] = useId(1, props.idPrefix ?? "icon-");
    const iconProps = svgProps[props.name];

    return (
        <>
            <svg
                aria-labelledby={`${htmlId}_title`}
                data-testid={props.name + "_testid"}
                focusable={false}
                id={htmlId}
                tabIndex={-1}
                viewBox={iconProps.viewbox}
                {...props}
                className={classnames("mets-icon", props.className)}>
                <use xlinkHref={`${iconProps.imageUrl}#${iconProps.imageId}`}></use>
            </svg>
            <span id={`${htmlId}_title`} className="accessibility-hidden">{t(`${props.name}_alt`)}</span>
        </>
    );

}

export default MetsIcon;